import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { transactionAPI } from '../../utils/api';
import { formatDate, getStatusBadgeClass, formatStatusText } from '../../utils/helpers';
import { Card } from '../../components/ui/card';
import { ArrowDownLeft, ArrowUpRight, TrendingUp } from 'lucide-react';

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await transactionAPI.getAll();
      setTransactions(response.data);
    } catch (error) {
      toast.error('Failed to load transactions');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-[60vh]"><div className="loading-spinner"></div></div>;

  return (
    <div className="space-y-8 animate-fadeIn" data-testid="transactions-page">
      <div>
        <h1 className="text-4xl font-bold text-black mb-2">Transactions</h1>
        <p className="text-gray-600">View all your transaction history</p>
      </div>

      <Card className="glass-card p-6 overflow-hidden">
        <div className="responsive-table-wrapper">
          <table className="w-full">
            <thead>
              <tr className="border-b border-white/5">
                <th className="text-left text-gray-600 text-sm font-medium pb-3">Type</th>
                <th className="text-left text-gray-600 text-sm font-medium pb-3">Asset</th>
                <th className="text-left text-gray-600 text-sm font-medium pb-3">Amount</th>
                <th className="text-left text-gray-600 text-sm font-medium pb-3">Status</th>
                <th className="text-left text-gray-600 text-sm font-medium pb-3">Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-gray-600 py-8">No transactions yet</td>
                </tr>
              ) : (
                transactions.map((tx) => (
                  <tr key={tx.id} className="table-row" data-testid={`transaction-${tx.id}`}>
                    <td className="py-4">
                      <div className="flex items-center space-x-2">
                        {tx.type === 'deposit' && <ArrowDownLeft className="w-4 h-4 text-green-400" />}
                        {tx.type === 'withdrawal' && <ArrowUpRight className="w-4 h-4 text-red-400" />}
                        {tx.type === 'trade' && <TrendingUp className="w-4 h-4 text-blue-400" />}
                        <span className="text-black capitalize">{tx.type}</span>
                      </div>
                    </td>
                    <td className="py-4 text-black">{tx.asset_symbol}</td>
                    <td className="py-4 text-black">{tx.amount}</td>
                    <td className="py-4">
                      <span className={`badge ${getStatusBadgeClass(tx.status)}`}>
                        {formatStatusText(tx.status)}
                      </span>
                    </td>
                    <td className="py-4 text-gray-600 text-sm">{formatDate(tx.created_at)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};

export default Transactions;
